'use client';
import { useAppSearchParams } from '../../shared/router/AppRouterContext';
import { useIntl } from 'react-intl';

import { Url } from '../../route/router';

import { navigateFullPage, reloadPage } from '../../utils/router';

import { DialogTitle } from '@vs-shop/ui/dialog';
import { IconExclamationCircle } from '@vs-shop/ui/icons';
import { Alert } from '@vs-shop/ui/alert';

import LoginForm from './LoginForm';

import { authModalAtom, AuthModalMode } from '@vs-shop/engine/atom/ui/authModal';
import { useAtomSet } from '@effect/atom-react';

export default function LoginModalAddProductToFavouritesContent() {
  const intl = useIntl();
  const setAuthModal = useAtomSet(authModalAtom);

  const searchParams = useAppSearchParams();
  const encodedParams = searchParams.toString();

  const switchToRegisterUrl = `${Url.registration}${encodedParams ? `?${encodedParams}` : ''}`;

  return (
    <div className="p-6">
      {/* Modal Header */}
      <div className="mb-3 flex">
        <DialogTitle className="text-lg leading-normal font-normal">
          {intl.formatMessage({
            id: 'component.authModal.login.heading',
            defaultMessage: 'Přihlášení',
          })}
        </DialogTitle>
      </div>

      {/* Favourites Message */}
      <Alert variant="warning" className="mb-6" icon={IconExclamationCircle}>
        {intl.formatMessage({
          id: 'component.authModal.addProductToFavourites.message',
          defaultMessage: 'Pro přidání produktu do oblíbených se musíte nejdříve přihlásit.',
        })}
      </Alert>

      {/* Login Form */}
      <LoginForm
        onSuccessAction={() => {
          setAuthModal((prev) => ({ ...prev, isOpen: false }));
          reloadPage();
        }}
        onSwitchToRegisterAction={() => {
          setAuthModal((prev) => ({ ...prev, isOpen: false }));
          navigateFullPage(switchToRegisterUrl);
        }}
        onSwitchToResetPasswordAction={() => {
          setAuthModal((prev) => ({ ...prev, mode: AuthModalMode.resetPassword }));
        }}
      />
    </div>
  );
}
